import React, {Component, lazy, Suspense} from 'react';
import styled from "styled-components";
import {Route, Switch} from "react-router-dom";
import TopBar from "./common/TopBar";
import Loader from "./common/Loader";
import {Colors} from "./assets/style/Constants";
import './assets/style/main.scss';
import {Auth} from "@aws-amplify/auth";

const AsyncExcelUploadPage = lazy(() =>
    import("./pages/ExcelUploadPage")
);

const AsyncRunFilesPage = lazy(() =>
    import("./pages/RunFilesPage")
);

const AsyncTimeSeriesPage = lazy(() =>
    import("./pages/time-series/TimeSeriesPage")
);

const AsyncHomePage = lazy(() =>
    import("./pages/home/HomePage")
);

const AsyncUpdateWarningsPage = lazy(() =>
    import("./pages/UpdateWarningsPage")
);

const AsyncRecipe = lazy(() =>
    import("./pages/recipe/RecipePage")
);

const AsyncSource = lazy(() =>
    import("./pages/source/SourcePage")
);

const AsyncJobs = lazy(() =>
    import("./pages/JobsPage")
);

const AsyncDeveloper = lazy(() =>
    import("./pages/developer/DeveloperPage")
);

const AsyncUpdateReportPage = lazy(() =>
    import("./pages/time-series/TimeSeriesUpdateReport")
);

const AsyncApiUsers = lazy(() =>
    import("./pages/api-users/ApiUsersPage")
);

const ScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  background-color: ${Colors.backgroundColor};
`;

const MainGridContainer = styled.div`
  flex: 1;
  grid-area: content;
  display: grid;
  grid-template-columns: minmax(1rem, 1fr) minmax(min-content, 1000px) minmax(1rem, 1fr);
  grid-template-rows: min-content auto;
  grid-template-areas:
    "top top top"
    "content content content";
  align-items: start;
`;

class App extends Component {

    checkUser() {
        Auth.currentAuthenticatedUser()
            .then(user => {
                if (!user) {
                    this.props.onStateChange('signIn', {});
                }
            })
            .catch(err => {
                console.log('Error with currentAuthenticatedUser', err);
                this.props.onStateChange('signIn', {});
            });
    }

    render() {
        if (this.props.authState === 'signedIn') {
            this.checkUser();
            return (
                <div>
                    <ScrollContainer>
                        <TopBar/>
                        <MainGridContainer>
                            <Suspense fallback={<Loader/>}>
                                <Switch>
                                    <Route exact path="/" children={<AsyncHomePage/>}/>
                                    <Route exact path="/home" children={<AsyncHomePage/>}/>
                                    <Route exact path="/excel-upload" children={<AsyncExcelUploadPage/>}/>
                                    <Route exact path="/run-files" children={<AsyncRunFilesPage/>}/>
                                    <Route exact path="/time-series/:tsnos?" children={<AsyncTimeSeriesPage/>}/>
                                    <Route exact path="/recipe/:tsno?" children={<AsyncRecipe/>}/>
                                    <Route exact path="/source/:tsno?" children={<AsyncSource/>}/>
                                    <Route exact path="/jobs" children={<AsyncJobs/>}/>
                                    <Route exact path="/developer" children={<AsyncDeveloper/>}/>
                                    <Route exact path="/time-series-update-report" children={<AsyncUpdateReportPage/>}/>
                                    <Route exact path="/api-users" children={<AsyncApiUsers/>}/>
                                    <Route exact path="/update-warnings" children={<AsyncUpdateWarningsPage/>}/>
                                </Switch>
                            </Suspense>
                        </MainGridContainer>
                    </ScrollContainer>
                </div>
            );
        } else {
            return null;
        }
    }
}

export default App;
